/** @deprecated */
export const allowedFormats = {
  video: [
    'video/mp4',
    'video/ogg',
    'video/quicktime',
    'video/x-ms-wmv',
    'video/x-flv',
  ],
  image: [
    'image/png',
    'image/gif',
    'image/jpeg',
    'image/jpg',
    'image/eps',
    'image/x-eps',
    'image/webp',
    'image/vnd.adobe.photoshop',
    'application/x-photoshop',
    'application/photoshop',
    'application/psd',
    'application/postscript',
    'application/eps',
    'application/x-eps',
  ],
  audio: [
    'audio/mp3',
    'audio/mpeg',
    'audio/MPA',
    'audio/mpa-robust',
    'audio/wav',
    'audio/x-wav',
    'audio/L16',
    'audio/L8',
    'audio/L20',
    'audio/L24',
  ],
}

export const flattenAcceptedFileTypes = (allowableFiles) =>
  allowableFiles
    .map((allowableFile) => allowedFormats[allowableFile])
    .reduce((prior, fileExtensions) => prior.concat(fileExtensions), [])

export const defineAllFileTypes = () => {
  const allFileTypes = flattenAcceptedFileTypes(Object.keys(allowedFormats))
  allowedFormats.all = allFileTypes
}

export const joinAcceptedFileTypes = (acceptedFileTypes) =>
  acceptedFileTypes.join(', ')
